import { useState } from 'react';
import { Alert, Box, Button, Paper, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../../api/auth';
import { setAdmin } from '../../store/admin.slice';
import { sessionExpiry } from '../../store/session';
import { ADMIN_STORAGE_KEY } from '../../api/client';
import { brand } from '../../app/config';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

export function AdminLoginPage() {
    useDocumentTitle('Login Admin');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [mail, setMail] = useState('');
    const [pass, setPass] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async () => {
        setSubmitting(true);
        setError(null);
        try {
            const data = await adminLogin({ mail, pass });
            const { expiresIn, ...info } = data;
            const session = { logged: true, ...info, exp: sessionExpiry(expiresIn) };
            localStorage.setItem(ADMIN_STORAGE_KEY, JSON.stringify(session));
            dispatch(setAdmin(session));
            navigate('/admin/events');
        } catch (_err) {
            setError('Credenziali non valide.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Box className="flex min-h-screen items-center justify-center bg-black/40 px-4">
            <Paper elevation={0} className="w-full max-w-sm border border-white/10 bg-black/50 p-8 backdrop-blur">
                <div className="mb-6 flex flex-col items-center gap-2">
                    <img src={brand.logo} alt={`${brand.name} logo`} className="h-14 w-auto" />
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                        Login Admin
                    </Typography>
                </div>
                <div className="flex flex-col gap-4">
                    <TextField label="Mail" fullWidth value={mail} onChange={(e) => setMail(e.target.value)} />
                    <TextField
                        label="Password"
                        fullWidth
                        type="password"
                        value={pass}
                        onChange={(e) => setPass(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                    />
                    {error && <Alert severity="error">{error}</Alert>}
                    <Button
                        variant="contained"
                        size="large"
                        disabled={submitting || !mail || !pass}
                        onClick={handleSubmit}
                    >
                        {submitting ? 'Accesso...' : 'Accedi'}
                    </Button>
                    <Button variant="text" onClick={() => navigate('/')}>
                        Torna alla home
                    </Button>
                </div>
            </Paper>
        </Box>
    );
}
